import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import QRCode from '../../assets/images/QRcodes/youtube4thMonth.jpg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDiscPoint, renderDynamicTable, renderIndentation, renderReportfield} from '../../utils/templateUtils';
import './fifthMonthPregnancy.scss';

export default function FifthMonthPregnancy(props) {
  // Ectopic Table State and Headers (exactly as SixthMonthPregnancy)
  const [ectopicRows, setEctopicRows] = useState([
    {
      outcome: '',
      conception: '',
      weeks: '',
      delivery: '',
      baby: '',
      complications: '',
      comments: ''
    }
  ]);
  const ecTopicHeaders = [
    {key: 'outcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic']},
    {key: 'conception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF']},
    {key: 'weeks', label: 'Weeks'},
    {key: 'delivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Medical', 'Surgical Miscarriage']},
    {key: 'baby', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Other']},
    {key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']},
    {key: 'comments', label: 'COMMENTS'}
  ];
  const [showTables, setShowTables] = useState({
    medication: true,
    test: true,
    ecTopic: true
  });
  const [formData, setFormData] = useState({
    picmeNumber: ''
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [testRows, setTestRows] = useState([
    {
      test: 'Hemoglobin (Hb)',
      result: 'g/Dl'
    },
    {
      test: '75g GTT',
      result: 'mg/dL'
    },
    {
      test: 'TSH',
      result: 'mIU/L'
    },
    {
      test: 'Urine C/S',
      result: ''
    }
  ]);

  const testHeaders = [
    {key: 'test', label: 'TEST'},
    {key: 'result', label: 'RESULT'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'T. Furnext / Globac XT/ Ferronomic plus',
      genericName: 'Ferrous bisglycinate + Folic Acid + Zinc + Methylcobalamin',
      dosage: '',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'C. Folvista',
      genericName: 'Methylfolate + Methylcobalamin + Pyridoxine',
      dosage: '1 capsule',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'T. Tricium XT / Ultra Ca',
      genericName: 'Calcium Carbonate + Vitamin D3',
      dosage: '1 tab',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'Vivamom',
      genericName: 'Maternal Protein Supplement',
      dosage: '2 scoops',
      freq: 'Morning & evening',
      withFood: 'With milk',
      duration: '1 box'
    },
    {
      sno: '5',
      drug: 'Siracilt',
      genericName: 'Silicone + Vitamin E + Plant Extracts',
      dosage: '-',
      freq: 'Twice daily',
      withFood: 'For Stretch Marks, If Needed',
      duration: '-'
    },
    {
      sno: '6',
      drug: 'T. Thyronorm',
      genericName: 'Levothyroxine Sodium',
      dosage: 'As advised',
      freq: '1-0-0',
      withFood: 'Empty stomach',
      duration: '30 days'
    },
    {
      sno: '7',
      drug: 'T. Glycomet SR',
      genericName: 'Metformin Hydrochloride (Sustained Release)',
      dosage: 'As advised',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '8',
      drug: 'Inj.Influvac Tetra',
      genericName: 'INACTIVATED INFLUENZA VACCINE(QUADRIVALENT)',
      dosage: '1 AMP IM',
      freq: 'STAT',
      withFood: '-',
      duration: '-'
    },
    {
      sno: '9',
      drug: 'T.Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dosage: '1 tablet',
      freq: '0-1-0',
      withFood: 'Oral',
      duration: 'Till 34 weeks'
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Brand Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'withFood', label: 'Timing / Instructions'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('fifthMonthPregnancyReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Spontaneous Pregnancy - 5 Month',
              picme_number: formData.picmeNumber,
              status: formData.picmeStatus
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  useEffect(() => {
    if (props.patientsData.picme_number) {
      setFormData(prev => ({...prev, picmeNumber: props.patientsData.picme_number, picmeStatus: 'Already Given'}));
    }
  }, [props.patientsData.picme_number]);

  return (
    <div id='FifthMonthPregnancyTemplate'>
      <div className='FifthMonthPregnancyTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>5th Month Antenatal Prescription – ASCAS</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <h3 className='mt-3'>OBSTETRIC SCORE :</h3>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='G:' name='g' value={formData.g} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='P:' name='p' value={formData.p} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='A:' name='a' value={formData.a} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='L:' name='l' value={formData.l} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Ectopic:' name='ecTopic' value={formData.ecTopic} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          {showTables.ecTopic && (
            <TemplateTable
              id='ecTopic'
              title=''
              headers={ecTopicHeaders}
              rows={ectopicRows}
              onRowsChange={(id, newRows) => setEctopicRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('ecTopic', setShowTables)}
            />
          )}
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Period of Gestation (POG):'
                name='pog'
                value={formData.pog}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='Weeks'
                minWidth='250px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='complaints' className='fw-bold' style={{width: '180px'}}>
              Complaints:
            </label>
            <textarea className='Textarea' placeholder='Complaints' id='complaints' name='complaints' onChange={handleChange} rows='3' cols='100' />
          </div>
          <h3 className='mt-3'>🩺 On Examination (O/E)</h3>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Pallor'
                name='pallor'
                value={formData.pallor}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Pedal Edema'
                name='pedalEdema'
                value={formData.pedalEdema}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Pulse Rate (PR):' name='pulse' value={formData.pulse} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' minWidth='160px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Previous Visit Weight:'
                name='previousWeight'
                value={formData.previousWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='200px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='perAbdomen' className='fw-bold' style={{width: '180px'}}>
              Per Abdomen (P/A):
            </label>
            <textarea className='Textarea' placeholder='Uterus 20 weeks, relaxed, liquor average, FHS good' id='perAbdomen' name='perAbdomen' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='scanReport' className='fw-bold' style={{width: '180px'}}>
              Scan Report:
            </label>
            <textarea className='Textarea' placeholder='Scan Report' id='scanReport' name='scanReport' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='fetalEcho' className='fw-bold' style={{width: '180px'}}>
              Fetal Echo:
            </label>
            <textarea className='Textarea' placeholder='Fetal Echo' id='fetalEcho' name='fetalEcho' onChange={handleChange} rows='3' cols='100' />
          </div>
          {showTables.test && (
            <TemplateTable
              id='test'
              title='🧪 TEST'
              headers={testHeaders}
              rows={testRows}
              onRowsChange={(id, newRows) => setTestRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('test', setShowTables)}
            />
          )}
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='💊 Medications Advised'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}
        <div className='bulletin'>
          <h4>🧪 Investigations Before Next Visit</h4>
          <ul class='ms-5 mb-0 pb-0'>
            <li>
              <b>Ultrasound:</b> FHR Screening
            </li>
            <li>
              {' '}
              <b>Blood Tests:</b> CBC, Urine Routine & Culture, 75g GTT, TS
            </li>
          </ul>

          <div className='row'>
            <div className='col-md-4 pb-2'>
              <SelectField
                label='📝 PICME Number'
                name='picmeStatus'
                value={formData.picmeStatus}
                options={[
                  {label: 'Registered', value: 'Registered'},
                  {label: 'Not Registered', value: 'Not Registered'},
                  {label: 'Already Given', value: 'Already Given'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='160px'
              />
            </div>
            {formData.picmeStatus === 'Registered' && (
              <div className='col-md-6'>
                <ReportFormInputWithLabel label='Enter PICME Number:' name='picmeNumber' value={formData.picmeNumber} required={false} onChange={handleChange} inputClassName='show' minWidth='200px' />
              </div>
            )}
            {formData.picmeStatus === 'Already Given' && <div className='col-md-6 me-2 mt-3 fw-bold'>{formData.picmeNumber}</div>}
          </div>
        </div>

        <div className='bulletin'>
          <h4>👣 Fetal Movements</h4>
          <p>Should start becoming perceptible. Just perceiving is enough — no counting needed at this stage.</p>
        </div>

        <div className='bulletin'>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <h4>Tips for 5th Month Pregnancy</h4>
              <ol className='px-3'>
                <li>Maintain a balanced diet with iron and calcium-rich foods.</li>
                <li>You may start feeling baby movements — enjoy bonding moments!</li>
                <li>Avoid long hours of standing; rest with legs slightly elevated.</li>
                <li>Keep taking prenatal vitamins and thyroid tablets as advised.</li>
                <li>Schedule your FHR screening ultrasound if not already done.</li>
                <li>
                  👉 Watch the second trimester guide by Dr. Aishwarya on Doctor Mommies YouTube:
                  <br />
                  <a href='https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                    Second Trimester – Doctor Mommies
                  </a>
                </li>
              </ol>
            </div>
            <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <h4>✅ ஐந்தாம் மாத கர்ப்பகால குறிப்புகள்</h4>
              <ol className='px-3'>
                <li>இரும்பு, கால்சியம் உள்ள உணவுகளை சீராக எடுத்துக்கொள்ளுங்கள்.</li>
                <li>குட்டியின் அசைவுகளை உணர தொடங்குவீர்கள் — சந்தோஷமாக அனுபவிக்கவும்.</li>
                <li>நீண்ட நேரம் நின்றுகொள்ள வேண்டாம்; கால்களை உயர்த்தி ஓய்வெடுக்கவும்.</li>
                <li>உங்கள் மாத்திரைகளை தவறாமல் தொடர்ந்து எடுத்துக்கொள்ளுங்கள்.</li>
                <li>FHR ஸ்கேன் செய்யும் தேதியை உறுதி செய்யுங்கள்.</li>
                <li>
                  👉 Doctor Mommies YouTube வீடியோவை பாருங்கள்:
                  <br />
                  <a href='https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                    நடுத்தர கர்ப்ப காலம் – Doctor Mommies
                  </a>
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='additionalAdvice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Advice:
          </label>
          <textarea className='Textarea' placeholder='add advice' id='additionalAdvice' name='additionalAdvice' onChange={handleChange} rows='4' cols='100' />
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='fifthMonthPregnancyReport'>
        <div id='fifthMonthPregnancyReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>5th Month Antenatal Prescription – ASCAS</h4>
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>OBSTETRIC SCORE :</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('G:', formData.g)}
            {renderReportfield('P:', formData.p)}
            {renderReportfield('A:', formData.a)}
            {renderReportfield('L:', formData.l)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Ectopic:', formData.ecTopic)}</div>
          {showTables.ecTopic &&
            renderDynamicTable(
              '',
              ['G Outcome', 'Mode of Conception', 'Weeks', 'Mode of Delivery', 'Baby Outcome', 'Complications', 'COMMENTS'],
              ['outcome', 'conception', 'weeks', 'delivery', 'baby', 'complications', 'comments'],
              ectopicRows
            )}
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Period of Gestation (POG):', `${formData.pog ? formData.pog : ''} Weeks`)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Complaints:', formData.complaints)}</div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🩺 On Examination (O/E)</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pallor:', formData.pallor)}
            {renderReportfield('Pedal Edema:', formData.pedalEdema)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pulse Rate (PR):', `${formData.pulse ? formData.pulse : ''} bpm`)}
            {renderReportfield('BP:', `${formData.bp ? formData.bp : ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('Previous Visit Weight:', `${formData.previousWeight ? formData.previousWeight : ''} kg`)}
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Per Abdomen (P/A):', formData.perAbdomen)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Scan Report:', formData.scanReport)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Fetal Echo:', formData.fetalEcho)}</div>

          {showTables.test && renderDynamicTable('🧪 TEST', ['TEST', 'RESULT'], ['test', 'result'], testRows)}
          {showTables.medication &&
            renderDynamicTable(
              '💊 Medications Advised',
              ['S.No', 'Brand Name', 'Generic Name', 'Dose', 'Frequency', 'Timing / Instructions', 'Duration'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'withFood', 'duration'],
              medicationRows
            )}

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🧪 Investigations Before Next Visit</h6>
          </div>
          {['Ultrasound: FHR Screening', 'Blood Tests: CBC, Urine Routine & Culture, 75g GTT, TSH'].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '5px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              {renderReportfield(item, '', {styleSec: {width: '100%'}})}
            </div>
          ))}
          <div style={{display: 'flex', marginTop: '5px', marginLeft: '-10px'}}>
            {formData.picmeStatus === 'Registered' || formData.picmeStatus === 'Already Given'
              ? renderReportfield('📝 PICME Number:', formData.picmeNumber)
              : renderReportfield('📝 PICME Number:', formData.picmeStatus)}
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>👣 Fetal Movements</h6>
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>
            {renderReportfield('Should start becoming perceptible. Just perceiving is enough — no counting needed at this stage.', '', {styleSec: {width: '100%'}})}
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>✅ Tips for 5th Month Pregnancy</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            {/* Left content */}
            <div>
              {[
                '1. Maintain a balanced diet with iron and calcium-rich foods.',
                '2. You may start feeling baby movements — enjoy bonding moments!',
                '3. Avoid long hours of standing; rest with legs slightly elevated.',
                '4. Keep taking prenatal vitamins and thyroid tablets as advised.',
                '5. Schedule your FHR screening ultrasound if not already done.',
                '👉 Watch the second trimester guide by Dr. Aishwarya on Doctor Mommies YouTube:',
                '<a href="https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">Second Trimester – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px', paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>

            {/* Right QR code */}
            <div>
              <img src={QRCode} alt='youtube qr' style={{width: '100px', height: '100px'}} />
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>✅ ஐந்தாம் மாத கர்ப்பகால குறிப்புகள்</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div>
              {[
                '1. இரும்பு, கால்சியம் உள்ள உணவுகளை சீராக எடுத்துக்கொள்ளுங்கள்.',
                '2. குட்டியின் அசைவுகளை உணர தொடங்குவீர்கள் — சந்தோஷமாக அனுபவிக்கவும்.',
                '3. நீண்ட நேரம் நின்றுகொள்ள வேண்டாம்; கால்களை உயர்த்தி ஓய்வெடுக்கவும்.',
                '4. உங்கள் மாத்திரைகளை தவறாமல் தொடர்ந்து எடுத்துக்கொள்ளுங்கள்.',
                '5. FHR ஸ்கேன் செய்யும் தேதியை உறுதி செய்யுங்கள்.',
                '👉 Doctor Mommies YouTube வீடியோவை பாருங்கள்:',
                '<a href="https://www.youtube.com/watch?app=desktop&v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">நடுத்தர கர்ப்ப காலம் – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px', paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Advice:', formData.additionalAdvice)}</div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
